module.exports = __webpack_public_path__ + "img/banner_wa@2x.0f78d06e.png";